import { HTTP_STATUS } from '../response';
import { Error } from '../error';

export interface FacebookLoginResponse {
	status: HTTP_STATUS;
	redirectUrl?: string;
	errors?: Error[];
}

export type FacebookLoginAction = (route: string) => Promise<FacebookLoginResponse>;
